/*
 * Copyright 2019 FedEx
 */
import { Component, OnInit } from '@angular/core';
import { LanguageTranslationService } from '../../services/language-translation.service';
import { CommonMethodUtilityService } from '../../services/common-method-utility.service';
import { environment } from '../../../environments/environment';
import { SubmitInfoService } from 'src/app/services/submit-info.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css']
})
export class ConfirmationComponent implements OnInit {

  country: string;
  language: string;
  awbNo: string;
  TRACKING_URL: string;
  CUSTOMER_SUPPORT_URL: string;
  WRITE_TO_FEDEX_URL: string;
  FAQ_URL: string;
  CONF_SCR_1: boolean = false;
  CONF_SCR_2: boolean = false;
  reasonCode: string;
  dePOA_EORI: boolean = false;
  resontwo: boolean = false;
  resontwofile: boolean = true;
  TRACKING_URL_PART3: string;
  CONF_SCR_3: boolean;

  constructor(
    private languageTranslationService: LanguageTranslationService,
    private commonMethodUtilityService: CommonMethodUtilityService,
    private submitInfoService: SubmitInfoService,
  ) { }

  ngOnInit() {

    this.country = sessionStorage.getItem('country').toLowerCase();
    this.language = sessionStorage.getItem('language').toLowerCase();
    this.languageTranslationService.useLang(sessionStorage.getItem('language'),sessionStorage.getItem('country'));
    this.awbNo = sessionStorage.getItem('awbNo');
    this.reasonCode = sessionStorage.getItem('reasonCode');
    
     if(this.country === 'de'){
       if(this.reasonCode === 'POA' || this.reasonCode === 'EORI'){
        this.dePOA_EORI = true;
       }else{
        this.dePOA_EORI = false;
       }
     }
    if ((this.reasonCode === 'POA' || this.reasonCode === 'EORI') && this.country == 'de') {
      this.resontwo = true;
      this.resontwofile = false;
    } 
    // if (this.reasonCode === 'POA' || this.reasonCode === 'EORI') {
    //   this.resontwo = false;
    //   this.resontwofile = true;
    // } 
    this.TRACKING_URL = environment.TRACKING_URL_PART1 + this.awbNo + environment.TRACKING_URL_PART2 + 'en_US' + environment.TRACKING_URL_PART3;
    this.enableSCRN(this.country);
  }

  enableSCRN(CTR: string) {

    let langCtryStr = this.commonMethodUtilityService.getLangCtryCombi(this.language, this.country);

    if (CTR === 'nl' || CTR === 'gb' || CTR === 'ie'|| CTR === 'fr'|| CTR === 'za'|| CTR === 'ae') {
      if (this.country && this.language) {
        this.WRITE_TO_FEDEX_URL = environment.WRITE_TO_FEDEX_URL_PART1 + langCtryStr + environment.WRITE_TO_FEDEX_URL_PART2;
        this.CUSTOMER_SUPPORT_URL = environment.CUSTOMER_SUPPORT_URL_PART1 + langCtryStr + environment.CUSTOMER_SUPPORT_URL_PART2;
        this.FAQ_URL = environment.FAQ_URL + langCtryStr + '/';
      }
      this.CONF_SCR_1 = true;
    }
    else if (CTR === 'ph') {
      this.WRITE_TO_FEDEX_URL = environment.WRITE_TO_FEDEX_URL_PART1 + langCtryStr + environment.WRITE_TO_FEDEX_URL_PART2;
      this.CUSTOMER_SUPPORT_URL = environment.CUSTOMER_SUPPORT_URL_PART1 + langCtryStr + environment.CUSTOMER_SUPPORT_URL_PART2;
      this.FAQ_URL = environment.FAQ_URL+ langCtryStr + '/';
      this.CONF_SCR_2 = true;
    } 
  }
}
